import { render, staticRenderFns } from "./schoolAnalysesnew.vue?vue&type=template&id=8b377f02&scoped=true"
import script from "./schoolAnalysesnew.vue?vue&type=script&lang=js"
export * from "./schoolAnalysesnew.vue?vue&type=script&lang=js"
import style0 from "./schoolAnalysesnew.vue?vue&type=style&index=0&id=8b377f02&prod&lang=scss&scoped=true"
import style1 from "./schoolAnalysesnew.vue?vue&type=style&index=1&id=8b377f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b377f02",
  null
  
)

export default component.exports